import { ReactComponent as Edit } from 'assett/icons/edit.svg';
import { showClaimCommentSection } from 'feature/claims/claimSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';
import { Button } from 'styles';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

const ClaimCommentsButton = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});

	const handleOpen = () => {
		dispatch(showClaimCommentSection());
	};

	return (
		<Button
			startIcon={<Edit />}
			variant="text"
			onClick={handleOpen}
			sx={{
				pr: 0,
				pb: '20px',
				textDecoration: 'underline',
				gap: '8px',
				'&:hover': {
					textDecoration: 'underline',
				},
			}}
		>
			{tClientLabels('claim.comments.button')}
		</Button>
	);
};

export default ClaimCommentsButton;
